<template lang="pug">
.contentContainer
    h1.TitleU {{name}}
    .HTMLContainer(v-html="body[year]")
</template>

<script>

export default {
    props: ['year'],
    data () {
        return {
            name: "THE VENUE",
            body: {
                2023: '<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt; line-height: 1.7;"><span style="font-size: 19px;">The MIMSVAI 2023 workshop is part of </span><a style="color: #e89700;" href="https://www.ubicomp.org/ubicomp2023/">UbiComp 2023↗︎</a>, which will be held in Cancún, Mexico.</p>',
                2022: '<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt; line-height: 1.7;"><span style="font-size: 19px;">The MIMSVAI 2022 workshop is part of </span><a style="color: #e89700;" href="https://www.ubicomp.org/ubicomp2022/">UbiComp 2022↗︎</a>, which will be held virtually.</p>',
                2021: '<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt; line-height: 1.7;"><span style="font-size: 19px;">The MIMSVAI 2021 workshop is part of (co-located with) </span><a href="https://www.ubicomp.org/ubicomp2021/" target="blank" style="color: #e89700;">UbiComp 2021↗︎</a><span>, which will be held virtually.</span></p>'
            }
        }
    },
    methods: {

    }
}
</script>

<style lang="sass" scoped>
@import "@/style/value.sass"
</style>



// WEBPACK FOOTER //
// src/components/mainPage/Contact.vue